import { BreakpointQueryName, rgba, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic = () => css`
  position: relative;
`;

export const navigationStatus: ThemedFunctor = ({
  theme,
}) => css`
  position: absolute;
  top: ${theme.remSize[200]};
  left: ${theme.remSize[200]};
  user-select: none;
  z-index: 1;
`;

export const navigationButtons: ThemedFunctor = ({
  theme,
}) => css`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    align-items: center;
  }
`;

export const navigationButton: ThemedFunctor = ({
  theme,
}) => css`
  padding: ${theme.remSize[200]};
  z-index: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: padding 0.5s ease;

  & > div {
    width: ${theme.remSize[500]};
    height: ${theme.remSize[500]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.color.foreground.neutral.default.high};
    background-color: ${rgba(theme.color.background.neutral.default.highest, 0.7)};
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {

    &:hover {
      padding: ${theme.remSize[200]} ${theme.remSize[300]};
    }

    & > div {
      width: ${theme.remSize[600]};
      height: ${theme.remSize[600]};
    }
  }
`;

export const loadingBox: ThemedFunctor = ({
  theme, $height,
}) => css`
  background-color: ${theme.color.background.neutral.default.high};
  position: relative;
  overflow: hidden;
  border: 1px solid ${theme.color.border.neutral.default.high};
  padding: ${theme.remSize[200]};
  display: flex;
  align-items: center;
  justify-content: center;

  ${$height && `
    height: ${$height};
  `}
`;
